var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "bee-spin bee-spin-spinning" }, [_vm._m(0)])
        : _vm._e(),
      _vm.$route.path && _vm.$route.path.indexOf("acm") > -1
        ? [
            _c(
              "a-locale-provider",
              { attrs: { locale: _vm.locale } },
              [_c("router-view")],
              1
            )
          ]
        : [_c("router-view")],
      _c("feedback", { attrs: { path: _vm.path } }),
      [
        "data-query",
        "chart-production",
        "comparison-analysis",
        "illegal-spots",
        "certificate-manage"
      ].indexOf(_vm.path) !== -1
        ? _c(
            "div",
            { staticClass: "home-btn" },
            [
              _c("router-link", { attrs: { to: "/start-page" } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/home-btn.png"),
                    alt: ""
                  }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _c("loading")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bee-spin-dot bee-spin-dot-spin" }, [
      _c("i", { staticClass: "bee-spin-dot-item" }),
      _c("i", { staticClass: "bee-spin-dot-item" }),
      _c("i", { staticClass: "bee-spin-dot-item" }),
      _c("i", { staticClass: "bee-spin-dot-item" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }